<template>
  <div class="user-details">
    <user-avatar :role-icon="roleIcon" />
    <div class="content">
      <span class="name">{{ user.username }}</span>
      <span class="email">{{ user.email }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props
interface Props {
  user?: Record<string, unknown>;
}

const props = withDefaults(defineProps<Props>(), {
  user: () => ({}),
});

// Computed
const roleIcon = computed(() => {
  return props.user.isStudent ? "Student32" : "Teacher32";
});
</script>

<style lang="scss">
@use "@styles/layout/z-map" as *;
@use "@styles/themes/sls-theme/tokens/colors" as *;
@use "@styles/themes/sls-theme/tokens/effects" as *;
@use "@styles/themes/sls-theme/tokens/spacing" as *;
@use "@styles/themes/sls-theme/tokens/typo" as *;

.user-details {
  position: absolute;
  display: flex;
  align-items: center;
  min-width: 15rem;
  background-color: $ui-01;
  margin-left: $spacing-05 !important;
  padding: $spacing-03 $spacing-05;
  border-radius: 10px;
  z-index: z-map("default");
  box-shadow: $shadow-01;

  .user-avatar {
    margin-right: $spacing-03;
    margin-left: 0;
  }

  > .content {
    display: flex;
    flex-flow: column wrap;

    .name {
      @include carbon--type-style("productive-heading-01", true);
      color: $text-01;
    }

    .email {
      @include carbon--type-style("label-01", true);
      color: $text-02;
    }
  }
}
</style>
